var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41.072,
    height: 36,
    viewBox: "0 0 41.072 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "desktop",
    d: "M51.739,85.176H14.709A2.023,2.023,0,0,0,12.688,87.2v21.861a2.024,2.024,0,0,0,2.021,2.023H30.047v5.756h-1.91a2.171,2.171,0,0,0-2.169,2.169v1.227a.943.943,0,0,0,.941.942H39.54a.943.943,0,0,0,.942-.942v-1.227a2.172,2.172,0,0,0-2.169-2.169H36.4v-5.756H51.739a2.024,2.024,0,0,0,2.021-2.024V87.2a2.023,2.023,0,0,0-2.021-2.021ZM14.709,86.787H51.739a.417.417,0,0,1,.411.411v19.17H14.3V87.2a.417.417,0,0,1,.411-.411Zm24.16,32.22v.558H27.578v-.558a.565.565,0,0,1,.558-.558H38.311a.565.565,0,0,1,.558.558Zm-4.079-2.169H31.658v-5.756H34.79Zm16.949-7.369H14.71a.417.417,0,0,1-.411-.411v-1.079H52.15v1.079a.417.417,0,0,1-.411.411Zm-21.916-20.1a.806.806,0,0,1,.806-.805h4.729a.806.806,0,0,1,0,1.611H30.628a.805.805,0,0,1-.8-.806Zm7.356,0a.805.805,0,0,1,.805-.805h.042a.806.806,0,0,1,0,1.611h-.042a.805.805,0,0,1-.806-.806Z",
    transform: "translate(-12.688 -85.176)",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.3ab7d26c0bba2f553aae9d4b301222eb.svg";
export { ForwardRef as ReactComponent };